import * as React from "react";
import { Box } from "@mui/material";
import { ParkingMapGrid } from "../components/parkingMapGrid";
import { ZoomPan } from "../components/zoomPan";
import { useParams } from 'react-router';


export default function Plano({ espacio, changeConBack, changeTitle, selected, onChangeSelected }) {
  const espacioId = useParams().id;
  const [espacioActual, setEspacioActual] = React.useState(null);
  const [slots, setSlots] = React.useState([]);
  // const [selected, setSelected] = React.useState([]);

  // Datos que se levantan desde la DB
  const rowCount = espacioActual?.rows ?? 10;
  const colCount = espacioActual?.cols ?? 20;
  const name = espacioActual?.nombre ?? 'Cine 2';

  React.useEffect(() => {
    changeTitle(name);
    changeConBack(true);
  }, [name]);

  React.useEffect(() => {
    // setEspacioActual({rows: espacio?.planos[0].rows, cols: espacio?.planos[0].cols, ...espacio});
    setEspacioActual({...espacio});
  }, [espacio]);

  React.useEffect(() => {
    setSlots(Object.values(espacio?.planos[0].posiciones ?? []) ?? []);
  }, [espacioActual]);

  return (
    <Box sx={{ p: 2, height: '100%' }}>
      <ZoomPan sx={{ width: "100%", height: '100%' }} minScale={0.6} maxScale={3}>
        {({ navigationEnabled }) => (
          <ParkingMapGrid
            name={name}
            rows={rowCount}
            cols={colCount}
            slots={slots}
            selectedIds={selected}
            onChangeSelected={onChangeSelected}
            cellSize={46}
            // ✅ cuando navigationEnabled=true => estamos en navegación => selección OFF
            selectionEnabled={!navigationEnabled}
          />
        )}
      </ZoomPan>
    </Box>
  );
}
